/* eslint no-console: 0 */

// import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import jQuery from 'jquery'
import Vue from 'vue'

import AppMobile from './letter-chooser/stencilease-lc-mobile.vue'
import App from './letter-chooser/stencilease-lc.vue'
import store from './letter-chooser/store'

Vue.use(BootstrapVue)

Vue.component('jQuery', jQuery)

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    store,
    render : function(createElement) {
      var w = window, d = document, e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          x = w.innerWidth || e.clientWidth || g.clientWidth;

      if (x < 1024) {
        return createElement(AppMobile);
      } else {
        return createElement(App);
      }
    }
  }).$mount('#stencilease-letter-chooser');
})
